export default ['360px', '600px', '768px', '1200px', '1440px'];
// export default ['576px', '768px', '992px', '1200px']
